import React, { useEffect, useState, useRef } from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";
import i18n, { use } from 'i18next';
import { useTranslation } from "react-i18next";
import { ConfigProvider, Menu, Pagination, Tooltip } from 'antd';

import FormHeader from "../components/form/FormHeader";
import FormText from "../components/form/FormText";
import Flex from "../components/core/Flex";
import FormButtonSecondary from "../components/form/FormButtonSecondary";
import { basename } from "../setting";

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Page>
      <StatusErrorImg src={`${process.env.PUBLIC_URL}/images/status_error.png`} alt="Loading Error" />
      <FormHeader style={{ marginBottom: 10 }}>{t("error:404NotFound.title")}</FormHeader>
      <FormText>{t("error:404NotFound.content1")}</FormText>
      <FormText>{t("error:404NotFound.content2")}</FormText>
      <FormText style={{ marginBottom: 40 }}>{t("error:404NotFound.content3")}</FormText>
      <FormButtonSecondary onClick={() => {
        navigate(`/${basename}`, { replace: true });
      }}>
        {t("backToHome")}
      </FormButtonSecondary>
    </Page>
  );
}

const Page = styled(Flex)`
  flex-direction: column;
`;

const StatusErrorImg = styled.img`
  width: 240px;
  height: 240px;
  margin-bottom: 64px;
`

export default NotFound;